const GATE_CB_PATTERN = /^\d{13}-[a-fA-F0-9]{6,8}$/
const GATE_CB_SESSION_KEY = 'gate_cb'

export function isValidGateCb(value) {
  const cb = Array.isArray(value) ? value[0] : value
  return GATE_CB_PATTERN.test(String(cb || ''))
}

function randomHex(length = 6) {
  const size = Math.max(1, Number(length) || 6)
  const bytes = new Uint8Array(Math.ceil(size / 2))

  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }

  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, size)
}

export function generateGateCb() {
  return `${Date.now()}-${randomHex(6)}`
}

function getOrCreateGateCb() {
  try {
    const saved = sessionStorage.getItem(GATE_CB_SESSION_KEY)
    if (isValidGateCb(saved)) return saved
  } catch {
    // sessionStorage 不可用时，继续生成当前会话标识
  }

  const next = generateGateCb()
  try {
    sessionStorage.setItem(GATE_CB_SESSION_KEY, next)
  } catch {
    // 隐私模式下可能禁止写入，不影响地址栏补参
  }
  return next
}

export function ensureGateCbOnAddressBar(path) {
  if (path === '/kfchat.html' || String(path || '').startsWith('/kfchat')) return

  const url = new URL(window.location.href)
  if (isValidGateCb(url.searchParams.get('cb'))) return

  url.searchParams.set('cb', getOrCreateGateCb())
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`
  )
}

export function buildInviteRegisterUrl(webDomain, invitationCode) {
  const base = String(webDomain || window.location.origin).replace(/\/$/, '')
  const code = String(invitationCode || '').trim()
  if (!code) return ''

  const params = new URLSearchParams({
    invitation_code: code,
    cb: generateGateCb()
  })
  return `${base}/register?${params.toString()}`
}
